import { useDispatch } from "react-redux";
import { NotificationInfo, showGlobalNotification } from "@src/features/interface/interfaceSlice";
import { useCallback } from 'react';

/**
 * A hook to show global notifications.
 * 
 * @returns A function to show a notification.
 */
const useKemuNotification = () => {
  const dispatch = useDispatch();

  const showNotification = useCallback((notification: NotificationInfo) => {
    dispatch(showGlobalNotification(notification));
  }, [dispatch]);

  return showNotification;
};

export default useKemuNotification;